export default {
  state: {
    inProgress: 0,
    completed: 0,
    status: [],
    departments: [],
    orders: [],
    completedOrders: [],
    router: [],
    typeOrder: null,
    click: false,
    pdf: null,
    pdfFile: null,
    eventForAddOrder: null,
    img: [],
    dataFirstStep: {},
    dataSecondStep: {},
    dataThirdStep: {},
    dataFourthStep: {},
    goShippoRates: [],
    itemsFirstStep: [],
    clickFirstStep: false,
    priceTotal: 0,
    loadingFile: false,
    validateFirstStep: false,
    secondStep: []
  },
  mutations: {
    setProgress(state, payload) {
      state.inProgress = payload
    },
    setCompleted(state, payload) {
      state.completed = payload
    },
    setStatus(state, payload) {
      state.status = payload
    },
    setDepartments(state, payload) {
      let dep = [{id: '', name: 'All'}]
      dep.push(...payload)
      state.departments = dep
    },
    setOrders(state, payload) {
      state.orders = payload
    },
    setCompletedOrders(state, payload) {
      state.completedOrders = payload
    },
    setRouterOrders(state, payload) {
      state.router[payload.name] = payload.value
    },
    setTypeOrder(state, payload) {
      sessionStorage.setItem('typeOrder', payload)
      state.typeOrder = payload
    },
    setClick(state, payload) {
      state.click = payload
    },
    setPdf(state, payload) {
      state.pdf = payload
    },
    setPdfClear(state) {
      state.pdf = null
    },
    setPdfFile(state, payload) {
      state.pdfFile = payload
    },
    setPdfFileClear(state) {
      state.pdfFile = null
    },
    setEventForAddOrder(state, payload) {
      state.eventForAddOrder = payload
    },
    setImages(state, payload) {
      if (!payload)
        state.img = []
      else
        state.img.push(payload)
    },
    setDataFirstStep(state, payload) {
      state.dataFirstStep = payload
    },
    setDataFirstStepClear(state) {
      state.dataFirstStep = []
    },
    setDataSecondStep(state, payload) {
      state.dataSecondStep = payload
    },
    setDataSecondStepClear(state) {
      state.dataSecondStep = []
    },
    setDataThirdStep(state, payload) {
      state.dataThirdStep = payload
    },
    setDataThirdStepClear(state) {
      state.dataThirdStep = []
    },
    setDataFourthStep(state, payload) {
      state.dataFourthStep = payload
    },
    setDataFourthStepClear(state) {
      state.dataFourthdStep = []
    },
    setGoShippoRates(state, payload) {
      state.goShippoRates = payload
    },
    setGoShippoRatesClear(state) {
      state.goShippoRates = []
    },
    setItemsFirstStep(state, payload) {
      state.itemsFirstStep[payload.key] = payload.value
    },
    setItemsFirstStepClear(state) {
      state.itemsFirstStep = []
    },
    setPriceFirstStep(state, payload) {
      state.priceTotal = payload
    },
    setLoadingFile(state, payload) {
      state.loadingFile = payload
    },
    setValidateFirstStep(state, payload) {
      state.validateFirstStep = payload
    },
    setSecondStep(state, payload) {
      state.secondStep = payload
    },
  },
  actions: {
    setProgress({commit}, payload) {
      commit('setProgress', payload)
    },
    setCompleted({commit}, payload) {
      commit('setCompleted', payload)
    },
    setStatus({commit}, payload) {
      sessionStorage.setItem('OrderStatus', JSON.stringify(payload))
      commit('setStatus', payload)
    },
    setDepartments({commit}, payload) {
      sessionStorage.setItem('OrderDepartments', JSON.stringify(payload))
      commit('setDepartments', payload)
    },
    setOrders({commit}, payload) {
      commit('setOrders', payload)
    },
    setCompletedOrders({commit}, payload) {
      commit('setCompletedOrders', payload)
    },
    setRouterOrders({commit}, payload) {
      commit('setRouterOrders', payload)
    },
    setTypeOrder({commit}, payload) {
      commit('setTypeOrder', payload)
    },
    setClick({commit}, payload) {
      commit('setClick', payload)
    },
    setPdf({commit}, payload) {
      commit('setPdf', payload)
    },
    setPdfClear({commit}) {
      commit('setPdfClear')
    },
    setPdfFile({commit}, payload) {
      commit('setPdfFile', payload)
    },
    setPdfFileClear({commit}) {
      commit('setPdfFileClear')
    },
    setEventForAddOrder({commit}, payload) {
      commit('setEventForAddOrder', payload)
    },
    setImages({commit}, payload) {
      commit('setImages', payload)
    },
    setDataFirstStep({commit}, payload) {
      commit('setDataFirstStep', payload)
    },
    setDataFirstStepClear({commit}) {
      commit('setDataFirstStepClear')
    },
    setDataSecondStep({commit}, payload) {
      commit('setDataSecondStep', payload)
    },
    setDataSecondStepClear({commit}) {
      commit('setDataSecondStepClear')
    },
    setDataThirdStep({commit}, payload) {
      commit('setDataThirdStep', payload)
    },
    setDataThirdStepClear({commit}) {
      commit('setDataThirdStepClear')
    },
    setDataFourthStep({commit}, payload) {
      commit('setDataFourthStep', payload)
    },
    setDataFourthStepClear({commit}) {
      commit('setDataFourthStepClear')
    },
    setGoShippoRates({commit}, payload) {
      commit('setGoShippoRates', payload)
    },
    setGoShippoRatesClear({commit}) {
      commit('setGoShippoRatesClear')
    },
    setItemsFirstStep({commit}, payload) {
      commit('setItemsFirstStep', payload)
    },
    setItemsFirstStepClear({commit}) {
      commit('setItemsFirstStepClear')
    },
    setPriceFirstStep({commit}, payload) {
      commit('setPriceFirstStep', payload)
    },
    setLoadingFile({commit}, payload) {
      commit('setLoadingFile', payload)
    },
    setValidateFirstStep({commit}, payload) {
      commit('setValidateFirstStep', payload)
    },
    setSecondStep({commit}, payload) {
      commit('setSecondStep', payload)
    },
    clearSecondStep({commit}) {
      commit('setSecondStep', [])
    }
  },
  getters: {
    getRouter(state) {
      return state.router
    },
    qtyProgress(state) {
      return state.inProgress
    },
    qtyCompleted(state) {
      return state.completed
    },
    orderStatus(state) {
      return state.status
    },
    orderDepartments(state) {
      return state.departments
    },
    orders(state) {
      return state.orders
    },
    checkQtyOrders(state) {
      return state.orders.length > 0
    },
    completedOrders(state) {
      return state.completedOrders
    },
    checkQtyCompletedOrders(state) {
      return state.completedOrders.length > 0
    },
    getTypeOrder(state) {
      if (state.typeOrder)
        return state.typeOrder
      else if (sessionStorage.getItem('typeOrder'))
        return sessionStorage.getItem('typeOrder')
    },
    getClick(state) {
      return state.click
    },
    getPdf(state) {
      return state.pdf
    },
    getPdfFile(state) {
      return state.pdfFile
    },
    getEventForAddOrder(state) {
      return state.eventForAddOrder
    },
    getImagesForOrders(state) {
      return state.img
    },
    getDataFirstStep(state) {
      return state.dataFirstStep
    },
    getDataSecondStep(state) {
      return state.dataSecondStep
    },
    getDataThirdStep(state) {
      return state.dataThirdStep
    },
    getDataFourthStep(state) {
      return state.dataFourthStep
    },
    getGoShippoRates(state) {
      return state.goShippoRates
    },
    getItemsFirstStep(state) {
      return state.itemsFirstStep
    },
    getPriceFirstStep(state) {
      return state.priceTotal
    },
    getLoadingFile(state) {
      return state.loadingFile
    },
    getValidateFirstStep(state) {
      return state.validateFirstStep
    },
    getSecondStep(state) {
      return state.secondStep
    }
  }
}
